<template>
  <StakeModal
    v-model="showModal"
    need-to-accept
  >
    <Stack
      gap="4"
      class="agreement"
    >
      <Title>
        AI Assistant Disclaimer
      </Title>

      <Subtitle>

        <p>This AI assistant aims to help your productivity, but is not a licensed advisor, and may make mistakes. </p>
        <br>
        <p>You acknowledge that:</p>
        <ul>
          <li>Responses may contain errors, outdated info, or omissions.</li>
          <li>You will not rely on AI responses as the sole basis for client advice</li>
          <li>You remain responsible for all advice and recommendations you provide</li>
        </ul>
      </Subtitle>

      <Buttons>
        <Button
          variant="primary"
          @click="acceptAgreement"
        >
        I Agree
        </Button>
      </Buttons>
    </Stack>
  </StakeModal>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';

import { Buttons, Button, Stack, StakeModal, Subtitle, Title } from '@stakeui';

const advisorStore = useAdvisorStore();
const showModal = ref(false);

function computeShowModal() {
  const advisor = advisorStore?.advisor;
  // While advisor info is loading, do not show the modal
  if (!advisor || typeof advisor.ask_anything_agreed === 'undefined') {
    showModal.value = false;
    return;
  }
  const agreed = !!advisor.ask_anything_agreed;
  showModal.value = !agreed;
}

onMounted(() => {
  computeShowModal();
});

watch(
  () => advisorStore.advisor,
  () => computeShowModal(),
  { immediate: false }
);

async function acceptAgreement() {
  try {
    await fetch('/api/v1/ask-anything/agree/', {
      method: 'POST',
      headers: advisorStore.headers,
    });
    advisorStore.setAdvisor({ ...(advisorStore.advisor || {}), ask_anything_agreed: true });
  } catch (e) {
  } finally {
    showModal.value = false;
  }
}
</script>

<style scoped>
.agreement {
  padding: 1em;

  ul {
    list-style-type: disc;
    margin: 0.5em 0 0 1.25em;
  }
}
</style>
